<div
  :class="{marginView: getEditor.marginView,marginsTotal:true}"
  :style="[getMarginViewStyle]"
>
  <div
    v-if="(getMargin.top || getMargin.bottom) && !getFormat.rounded"
    class="formatInfo formatMarginL"
  >
    {{getMargin.top+getMargin.bottom+getFormat.height}} {{ $t('cm') }}
  </div>
  <div
    v-if="(getMargin.left||getMargin.right)"
    class="formatInfo formatMarginT"
  >
    {{getMargin.left+getMargin.right+getFormat.width}} {{ $t('cm') }}
  </div>
</div>
